import { isArray, isEmpty, isNotEmpty, isObject, resolveFirst } from "@churchofjesuschrist/maps-utils";
import Position from "./Position";
export default class BoundingBox {
  static create(west, south, east, north) {
    return BoundingBox.toGeoJSON({
      west,
      south,
      east,
      north
    });
  }
  static toJSON(boundingBox) {
    if (isArray(boundingBox)) {
      let half = boundingBox.length / 2;
      let southWest = Position.toJSON(boundingBox.slice(0, half));
      let northEast = Position.toJSON(boundingBox.slice(half));
      if (southWest && northEast) {
        return {
          southWest,
          northEast
        };
      }
    } else if (isObject(boundingBox)) {
      let sw = resolveFirst(boundingBox, "southWest", "sw", "getSouthWest");
      let ne = resolveFirst(boundingBox, "northEast", "ne", "getNorthEast");
      if (isNotEmpty(sw) && isNotEmpty(ne)) {
        let southWest = Position.toJSON(sw);
        let northEast = Position.toJSON(ne);
        if (southWest && northEast) {
          return {
            southWest,
            northEast
          };
        }
      }
      let west = resolveFirst(boundingBox, "west", "w");
      let south = resolveFirst(boundingBox, "south", "s");
      let east = resolveFirst(boundingBox, "east", "e");
      let north = resolveFirst(boundingBox, "north", "n");
      let southWest = Position.toJSON([west, south]);
      let northEast = Position.toJSON([east, north]);
      if (southWest && northEast) {
        return {
          southWest,
          northEast
        };
      }
    }
    return null;
  }
  static toGeoJSON(boundingBox) {
    let bbox = BoundingBox.toJSON(boundingBox);
    if (bbox) {
      if (isEmpty(bbox.southWest.altitude) && isEmpty(bbox.northEast.altitude)) {
        return [bbox.southWest.longitude, bbox.southWest.latitude, bbox.northEast.longitude, bbox.northEast.latitude];
      } else {
        return [bbox.southWest.longitude, bbox.southWest.latitude, bbox.southWest.altitude || 0.0, bbox.northEast.longitude, bbox.northEast.latitude, bbox.northEast.altitude || 0.0];
      }
    }
    return null;
  }
  static isBoundingBox(value) {
    return !!BoundingBox.toJSON(value);
  }
  static getSouthWest(boundingBox) {
    let bbox = BoundingBox.toJSON(boundingBox);
    return bbox?.southWest;
  }
  static getNorthEast(boundingBox) {
    let bbox = BoundingBox.toJSON(boundingBox);
    return bbox?.northEast;
  }
  static getWest(boundingBox) {
    let bbox = BoundingBox.toJSON(boundingBox);
    return bbox?.southWest?.longitude;
  }
  static getSouth(boundingBox) {
    let bbox = BoundingBox.toJSON(boundingBox);
    return bbox?.southWest?.latitude;
  }
  static getEast(boundingBox) {
    let bbox = BoundingBox.toJSON(boundingBox);
    return bbox?.northEast?.longitude;
  }
  static getNorth(boundingBox) {
    let bbox = BoundingBox.toJSON(boundingBox);
    return bbox?.northEast?.latitude;
  }
  static equals(boundingBox1, boundingBox2) {
    if (boundingBox1 === boundingBox2) {
      return true;
    }
    let bbox1 = BoundingBox.toJSON(boundingBox1);
    let bbox2 = BoundingBox.toJSON(boundingBox2);
    if (bbox1 && bbox2) {
      return Position.equals(bbox1.southWest) && Position.equals(bbox1.northEast);
    }
    return false;
  }
  static nearlyEquals(boundingBox1, boundingBox2) {
    if (boundingBox1 === boundingBox2) {
      return true;
    }
    let bbox1 = BoundingBox.toJSON(boundingBox1);
    let bbox2 = BoundingBox.toJSON(boundingBox2);
    if (bbox1 && bbox2) {
      return Position.nearlyEquals(bbox1.southWest) && Position.nearlyEquals(bbox1.northEast);
    }
    return false;
  }
}